import Script from "next/script";
const lotameClientId = "15969";

/*
  <link rel="preconnect" href="https://tags.crwdcntrl.net">
  <link rel="preconnect" href="https://bcp.crwdcntrl.net">
  <link rel="dns-prefetch" href="https://tags.crwdcntrl.net">
  <link rel="dns-prefetch" href="https://bcp.crwdcntrl.net">
*/

const Lotame = () => {
  return (
    <>
      <Script
        id="lotame"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
    var targetAndDisplayAds = function(audienceArray) {
      console.log(audienceArray);
    }
    ! function() {
      var lotameClientId = '${lotameClientId}';
      var audLocalStorageKey = 'lotame_' + lotameClientId + '_auds';

      // Adjust this timing as needed
      var maxAudienceWaitMillis = 500;

      // Set up fallback logic if timeout is reached
      var audienceReadyTimeoutId = window.setTimeout(function() {
        var localStorageAudiences = [];

        try {
          var tempAudiences = window.localStorage.getItem(audLocalStorageKey) || '';

          if (tempAudiences) {
            localStorageAudiences = tempAudiences.split(',');
          }
        } catch(e) {
        } finally {
          targetAndDisplayAds(localStorageAudiences);
        }
      }, maxAudienceWaitMillis);

      var audienceReadyCallback = function(profile) {
        // Get audience string & Call your company's Ad Display function
        var lotameAudiences = profile.getAudiences() || [];

        // Cancel the timeout
        window.clearTimeout(audienceReadyTimeoutId);

        targetAndDisplayAds(lotameAudiences);
      };

      // Lotame Config
      var lotameTagInput = {
        data: {},
        config: {
          audienceLocalStorage: audLocalStorageKey,
          onProfileReady: audienceReadyCallback
        }
      };

      // Lotame initialization
      var lotameConfig = lotameTagInput.config || {};
      var namespace = window['lotame_' + lotameClientId] = {};
      namespace.config = lotameConfig;
      namespace.data = lotameTagInput.data || {};
      namespace.cmd = namespace.cmd || [];
    } (); `,
        }}
      />
      <Script
        async
        src={`https://tags.crwdcntrl.net/lt/c/${lotameClientId}/lt.min.js`}
      />
    </>
  );
};

export default Lotame;
